export class AuthTokenExpired extends Error {
  constructor(message = "Срок действия токена истек") {
    super(message);
  }
}